var React = require('react');

function CheckGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14 4.54666L6.50754 12.0391L2 7.53157L3.05533 6.47624L6.50754 9.92846L12.9447 3.49133L14 4.54666Z","fill":"#45BA7B"}));
}

CheckGreen.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckGreen;

CheckGreen.default = CheckGreen;
